import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  class: "container-fluid bg-primary mb-5 wow fadeIn",
  "data-wow-delay": "0.1s",
  style: {"padding":"35px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-2" }
const _hoisted_4 = { class: "col-sm-10" }
const _hoisted_5 = { class: "row g-2" }
const _hoisted_6 = { class: "col-sm-4" }
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-sm-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.keyword) = $event)),
                type: "text",
                class: "form-control border-0 py-3",
                placeholder: "Search by location or keyword"
              }, null, 512), [
                [_vModelText, _ctx.search.keyword]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.propertyType) = $event)),
                class: "form-select border-0 py-3"
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, "Property Type", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypes, (type) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: type.name,
                    value: type.name
                  }, _toDisplayString(type.name), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.search.propertyType]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.offerType) = $event)),
                class: "form-select border-0 py-3"
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "Offer Type", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offerTypes, (offer) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: offer,
                    value: offer
                  }, _toDisplayString(offer), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.search.offerType]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-dark border-0 w-100 py-3",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
          }, "Search")
        ])
      ])
    ])
  ]))
}